// Shared employee status pill (active / on_leave / inactive). Theme-aware.
import React from 'react';
import {
  EMPLOYEE_STATUS_META,
  resolveEmployeeStatus,
  type EmployeeStatus,
} from '@/features/shared/status/employeeStatus';

export const EmployeeStatusBadge: React.FC<{
  /** Either a canonical status, or a raw backend status string. */
  status?: EmployeeStatus | string | null;
  /** When true, forces "on leave" (e.g. the person is out today). */
  isOutNow?: boolean;
  /** Emoji dot (default) vs a small colored dot. */
  variant?: 'emoji' | 'dot';
  className?: string;
}> = ({ status, isOutNow, variant = 'emoji', className = '' }) => {
  const s = resolveEmployeeStatus(typeof status === 'string' ? status : status ?? '', isOutNow);
  const meta = EMPLOYEE_STATUS_META[s];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium ${meta.badge} ${className}`}
    >
      {variant === 'emoji' ? (
        <span aria-hidden>{meta.emoji}</span>
      ) : (
        <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} aria-hidden />
      )}
      {meta.label}
    </span>
  );
};

export default EmployeeStatusBadge;
